import React from 'react'

import { RemoveRowAction, DeleteRowAction } from '@front/squirtle/components/FormTable/Actions/'

const ButtonComponent = ({ rowId, onRemove, ...props }) =>
  rowId === '_create' ? <RemoveRowAction icon='delete' /> : <DeleteRowAction onClick={onRemove} />

export default React.memo(ButtonComponent)
